import TableLoadingIndicator from "./TableLoadingIndicator";

function TableLoadingFallback(): JSX.Element {
  return (
    <div className="w-full p-5">
      <TableLoadingIndicator />
    </div>
  );
}

export default TableLoadingFallback;

